//export const VolumeText =  'Volume, specifically greater than normal volume, typically indicates important news released on that day, a set-up for upcoming news, or may even suggest a change in investor sentiment In addition how options are priced gives you an indication of sentiment on the underlying stock or'

import React from 'react';

const FONT = 'Helvetica';
const Smallertext = '< 10 = Very Bullish';
const GraterText = ' > 90 = Very Bearish';
const secondBoxItm = ' ITM = > 0.50';
const secondBoxOTM = 'OTM = < 0.50';
const width = window.innerWidth;
var isMobile = width < 850;
let videoHeight = isMobile ? '150' : '300';

export const openNOC = (item) => localStorage.setItem('SYMBOL', item);

export const format1Decimal = (number) =>
  (Math.round(number * 10) / 10).toFixed(1);

const styles = {
  toolTipWhiteTextMain: {
    display: 'flex',
    justifyContent: 'center',
    margin: '5px 0px 15px 0px',
  },
  toolTipWhiteText: {
    backgroundColor: 'white',
    width: '80%',
    fontSize: 14,
    padding: '15px',
    fontWeight: 'w400',
    borderRadius: '20px',
  },
  headingText: {
    fontWeight: 'bold',
    fontFamily: FONT,
    fontSize: 18,
  },
  NormalText: {
    fontSize: 14,
    fontFamily: FONT,
  },

  textHeading: {
    fontWeight: 'bold',
    fontFamily: FONT,
    fontSize: 16,
    margin: '25px 0px 0px 0px',
  },
  imageDiv: {
    margin: '25px 0px 0px 0px',
    display: 'flex',
    justifyContent: 'center',
  },
  scrollAbleDiv: {
    height: '200px',
    overflowY: 'scroll',
    overflowX: 'hidden',
    marginTop: '15px',
  },

  scrollAbleDivMobile: {
    height: '200px',
    overflowY: 'scroll',
    overflowX: 'hidden',
  },
};
export const VolumeText = (
  <div style={{ margin: '5%' }}>
    <div>
      <div style={styles.headingText}> Volume and Options Sentiment </div>
      <div style={{ ...styles.NormalText, marginLeft: '0px' }}>
        Volume, specifically greater than normal volume, typically indicates
        important news released on that day, a set-up for upcoming news, or may
        even suggest a change in investor sentiment. In addition, how options
        are priced gives you an indication of sentiment on the underlying stock
        or etf.
      </div>
      <div style={styles.imageDiv}>
        <div style={{ width: isMobile ? '300px' : '500px' }}>
          <iframe
            width="200"
            height={videoHeight}
            src="https://player.vimeo.com/video/712465011?h=751e62ea58&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            title="Stock - Volume-Options Sentiment"
            style={{ width: isMobile ? '300px' : '500px', maxWidth: '500px' }}
          />
        </div>
      </div>
    </div>
    <div style={isMobile ? styles.scrollAbleDivMobile : styles.scrollAbleDiv}>
      <div style={styles.textHeading}>Volumes</div>
      <div style={styles.NormalText}>
        This gives you a snapshot of today’s Option and Stock Volume relative to
        the 30-day average. A quick glance at the ratio can tell you whether it
        is trading above or below average.
      </div>
      <div style={styles.toolTipWhiteTextMain}>
        {' '}
        <div style={styles.toolTipWhiteText}>
          {' '}
          Tip: You should be looking for outliers where the ratios are greater
          than 2x, or perhaps there ae multiple days in a row with ratios
          greater than 1.3x
        </div>
      </div>
      <div style={styles.textHeading}>Options Sentiment</div>
      <div style={styles.NormalText}>
        The Options Sentiment is giving you a glimpse at how the Option Premiums
        are reflecting sentiment. The chart is using Skew percentile data from
        that time frame. For example: 92 means that Skew is in the 92nd
        percentile over the last year. Here are the following sentiment
        indicator ranges:{' '}
      </div>
      <div style={styles.NormalText}>{GraterText} </div>
      <div style={styles.NormalText}>61-90 = Bearish</div>
      <div style={styles.NormalText}>40-60 = Neutral</div>

      <div style={styles.NormalText}>10-39 = Bullish</div>

      <div style={styles.NormalText}>{Smallertext}</div>

      <div style={styles.toolTipWhiteTextMain}>
        <div style={styles.toolTipWhiteText}>
          {' '}
          Tip: The Options Sentiment indicators can lead you to think about
          using certain strategies to increase your edge. You should focus you
          attention when you see the extremes, Very Bearish or Very Bullish.{' '}
        </div>
      </div>
    </div>
  </div>
);

export const DataBox1 = (
  <div style={{ margin: '5%' }}>
    <div>
      <div style={styles.headingText}> Most Active Strikes by Volume</div>
      <div style={{ ...styles.NormalText, marginLeft: '0px' }}>
        This data box returns the most active strikes in XYZ today Sorted by
        Volume. You can also change the calendar date to get historical data.
      </div>
      <div style={styles.imageDiv}>
        <div style={{ width: isMobile ? '300px' : '500px' }}>
          <iframe
            width="200"
            height={videoHeight}
            src="https://player.vimeo.com/video/712465007?h=8c9a180fbd&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            title="Stock - Volume-Options Sentiment"
            style={{ width: isMobile ? '300px' : '500px', maxWidth: '500px' }}
          />
        </div>
      </div>
    </div>
    <div style={isMobile ? styles.scrollAbleDivMobile : styles.scrollAbleDiv}>
      <div style={styles.textHeading}>Volume</div>
      <div style={styles.NormalText}>
        Click any cell to get a detailed look (i.e. volume, Implied Volatility
        and Stock Price by time during the day) at the volume for that specific
        option.
      </div>
      <div style={styles.toolTipWhiteTextMain}>
        {' '}
        <div style={styles.toolTipWhiteText}>
          {' '}
          Tip: Use this data set to give you a general sense of what is going on
          in the name. Usually, the top few rows tell most of the “story” of
          where the action is.
        </div>
      </div>
      <div style={styles.textHeading}>Expiry</div>
      <div style={styles.NormalText}>
        Click any cell to access the New Options Chain for a broader look at
        current markets across all expirations and the Risk Reward Stock Price.{' '}
      </div>
      <div style={styles.textHeading}>Bid%, Mid%, Ask% </div>
      <div style={styles.NormalText}>
        The volume is divided into 3 percentage buckets determined by where the
        premium traded relative to the market at the time of the trade. This is
        not precise but the machine’s best guess using proprietary proximity
        analysis, meaning it doesn’t have to trade on the bid to fall in the
        bid% bucket. Volume that is “close to the bid” could be thrown into the
        Bid% bucket.{' '}
      </div>
      <div style={styles.toolTipWhiteTextMain}>
        <div style={styles.toolTipWhiteText}>
          Tip: Our main goal is to look for buyers. A good sign is seeing a
          higher % on the Ask. That does not make it definitive as discussed in
          3 Steps to Profit. But it’s a good start.
        </div>
      </div>
      <div style={styles.textHeading}>OI</div>
      <div style={styles.NormalText}>
        Click any cell to access more details about the Open Interest, including
        historical Options Premiums, Volumes, OI and other Historical closing
        data.
      </div>
      <div style={styles.textHeading}>IV and Chg </div>
      <div style={styles.NormalText}>
        {' '}
        This is where you will see the Implied Volatility (IV) of the option and
        the 1-day change in the IV.{' '}
      </div>
      <div style={styles.toolTipWhiteTextMain}>
        <div style={styles.toolTipWhiteText}>
          Tip: In general, buyers of that option are indicated with a positive
          1-day change. Keep in mind, this is not always the case. Sometimes
          comparing the SPY (S&P500 ETF) IV change over 1-day helps add context.
          If the SPY IV change is negative and a Stock IV is flat, then that
          might also indicate better demand.{' '}
        </div>
      </div>
      <div style={styles.textHeading}> Trades </div>
      <div style={styles.NormalText}>
        {' '}
        This is the number of trades that have taken place to reach the total
        volume in the “Volume” column. A large Volume number with a very small
        number of trades indicates a block options trade by a Top 1%
        institutional player.{' '}
      </div>
      <div style={styles.toolTipWhiteTextMain}>
        <div style={styles.toolTipWhiteText}>
          {' '}
          Tip: I generally only care about this column if I see the example
          shown above. Sometimes The Top 1% buy all in one shot and sometimes
          they buy 10 contracts 1,000x.{' '}
        </div>
      </div>
    </div>
  </div>
);

export const DataBox3 = (
  <div style={{ margin: '5%' }}>
    <div>
      <div style={styles.headingText}> Top Changes in Open Interest</div>
      <div style={{ ...styles.NormalText, marginLeft: '0px' }}>
        This data box highlights the largest changes in XYZ strikes from
        yesterday. You can also change the calendar date to get historical data.
      </div>
      <div style={styles.imageDiv}>
        <div style={{ width: isMobile ? '300px' : '500px' }}>
          <iframe
            width="200"
            height={videoHeight}
            src="https://player.vimeo.com/video/712464990?h=a321d93139&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            title="Stock - Volume-Options Sentiment"
            style={{ width: isMobile ? '300px' : '500px', maxWidth: '500px' }}
          />
        </div>
      </div>
    </div>
    <div style={isMobile ? styles.scrollAbleDivMobile : styles.scrollAbleDiv}>
      <div style={styles.textHeading}>OI and Chg</div>
      <div style={styles.NormalText}>
        This gives you the Open Interest and the one-day change in Open Interest
        for a specific option. It’s important because it can give you some
        indication of what you may have missed the previous day. Click any{' '}
      </div>
      <div style={styles.textHeading}>Volume </div>
      <div style={styles.NormalText}>
        Click any cell to get a detailed look (i.e. volume, Implied Volatility
        and Stock Price by time during the day) at the volume for that specific
        option.{' '}
      </div>
      <div style={styles.toolTipWhiteTextMain}>
        <div style={styles.toolTipWhiteText}>
          {' '}
          Tip: Use this data set to give you a general sense of what is going on
          in the name. Usually, the top few rows tell most of the “story” of
          where the action is.{' '}
        </div>
      </div>
      <div style={styles.textHeading}>Expiry</div>
      <div style={styles.NormalText}>
        Click any cell to access the New Options Chain for a broader look at
        current markets across all expirations and the Risk Reward Stock Price.{' '}
      </div>
      <div style={styles.textHeading}>Bid%, Mid%, Ask% </div>
      <div style={styles.NormalText}>
        The volume is divided into 3 percentage buckets determined by where the
        premium traded relative to the market at the time of the trade. This is
        not precise but the machine’s best guess using proprietary proximity
        analysis, meaning it doesn’t have to trade on the bid to fall in the
        bid% bucket. Volume that is “close to the bid” could be thrown into the
        Bid% bucket.{' '}
      </div>
      <div style={styles.toolTipWhiteTextMain}>
        <div style={styles.toolTipWhiteText}>
          Tip: Our main goal is to look for buyers. A good sign is seeing a
          higher % on the Ask. That does not make it definitive as discussed in
          3 Steps to Profit. But it’s a good start.
        </div>
      </div>

      <div style={styles.textHeading}>IV and Chg </div>
      <div style={styles.NormalText}>
        {' '}
        This is where you will see today’s Implied Volatility (IV) of the option
        and the 1-day change in the IV.{' '}
      </div>
      <div style={styles.toolTipWhiteTextMain}>
        <div style={styles.toolTipWhiteText}>
          Tip: In general, buyers of that option are indicated with a positive
          1-day change. Keep in mind, this is not always the case. Sometimes
          comparing the SPY (S&P500 ETF) IV change over 1-day helps add context.
          If the SPY IV change is negative and a Stock IV is flat, then that
          might also indicate better demand.{' '}
        </div>
      </div>
    </div>
  </div>
);

export const DataBox2 = (
  <div style={{ margin: '5%' }}>
    <div>
      <div style={styles.headingText}> Top Individual Trades </div>
      <div style={{ ...styles.NormalText, marginLeft: '0px' }}>
        This data box returns details of the largest individual trades in XYZ
        today sorted by the number of contracts, or “Size.” You can also change
        the calendar date to get historical data.
      </div>
      <div style={styles.imageDiv}>
        <div style={{ width: isMobile ? '300px' : '500px' }}>
          <iframe
            width="200"
            height={videoHeight}
            src="https://player.vimeo.com/video/712464995?h=a932f30980&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            title="Stock - Volume-Options Sentiment"
            style={{ width: isMobile ? '300px' : '500px', maxWidth: '500px' }}
          />
        </div>
      </div>
    </div>
    <div style={isMobile ? styles.scrollAbleDivMobile : styles.scrollAbleDiv}>
      <div style={styles.textHeading}>Size</div>
      <div style={styles.NormalText}>
        Size is the number of contracts on a particular trade with details shown
        to the right. Size is not the total volume that we see above in the
        “Most Active XYZ Strikes by Volume” data set. For example, a particular
        XYZ strike may have total volume on the day of 10,000 contracts but the
        largest trade may have only been 2,000 contracts. This data set picks up
        the 2,000 contracts.
      </div>
      <div style={styles.toolTipWhiteTextMain}>
        {' '}
        <div style={styles.toolTipWhiteText}>
          {' '}
          Tip: The data set is very helpful in finding details on “spreads” and
          helping us determine the direction of those spreads. Use with columns
          “Side,” “Condition,” and “Time”
        </div>
      </div>
      <div style={styles.textHeading}>Expiry</div>
      <div style={styles.NormalText}>
        Click any cell to access the New Options Chain for a broader look at
        current markets across all expirations and the Risk Reward Stock Price.{' '}
      </div>
      <div style={styles.textHeading}>Side </div>
      <div style={styles.NormalText}>
        This gives you the side of the market that the option traded. “BidSide”
        or “BelowBid” indicates a sale, while “AskSide” and “AboveAsk” indicates
        a buyer. “MidMkt” is inconclusive{' '}
      </div>
      <div style={styles.toolTipWhiteTextMain}>
        <div style={styles.toolTipWhiteText}>
          Tip: Sometimes the results come back and it’s easy to decipher what
          happened. But sometimes you can get two options that traded as a
          spread with both on the “AskSide” or show “MidMkt.” In these
          instances, you can use the Open Interest Modal (Pop-up) to determine
          historical dates and then use the Calendar to retrieve Historical Data
          for more clues.
        </div>
      </div>
      <div style={styles.textHeading}>Stock and Chg</div>
      <div style={styles.NormalText}>
        This gives you the Stock Price and the change on the day at the time
        this option traded.
      </div>
      <div style={styles.toolTipWhiteTextMain}>
        <div style={styles.toolTipWhiteText}>
          {' '}
          Tip: Consider what has happened to the stock after it traded. This
          gives another clue to whether the option was a bought or a sold. It
          also gives you some idea of how strong the stock is.{' '}
        </div>
      </div>
      <div style={styles.textHeading}>Condition </div>
      <div style={styles.NormalText}>
        {' '}
        This will give you more information on the type of trade that happened:{' '}
      </div>
      <div style={styles.NormalText}>
        {' '}
        SWEEP – Sweep trade done, which means the trade was done across
        several/all markets at one time.{' '}
      </div>
      <div style={styles.NormalText}>
        {' '}
        SPRD/FLR – This is a Spread trade, where the market makers took the
        other side of the trade.{' '}
      </div>
      <div style={styles.NormalText}>
        {' '}
        SPRD/CROSS - This is a Spread trade, where the Broker (i.e. Goldman
        Sachs) took the other side of the trade.{' '}
      </div>

      <div style={styles.NormalText}> AUCT </div>
      <div style={styles.toolTipWhiteTextMain}>
        <div style={styles.toolTipWhiteText}>
          {' '}
          Tip: Just because the “Condition” does not say “SPRD” (Spread), it can
          still be part of a spread. Sometimes the trade tickets don’t get
          processed correctly.{' '}
        </div>
      </div>
      <div style={styles.textHeading}> Volume </div>
      <div style={styles.NormalText}>
        {' '}
        This is the total Volume for that Options Strike. It will always be
        greater or equal to the Size column.{' '}
      </div>
      <div style={styles.toolTipWhiteTextMain}>
        <div style={styles.toolTipWhiteText}>
          {' '}
          Tip: Just because the Size of the trade is dwarfed by the Volume, it
          does not mean that it was not a Top 1% player. Sometimes they buy in
          pieces during the day that add up to most of the volume. Click on the
          “Size” cell to access the details of the trade and get a feel for how
          the volume accumulated during the day.
        </div>
      </div>
      <div style={styles.textHeading}> OI </div>
      <div style={styles.NormalText}>
        {' '}
        Click any cell to access more details about the Open Interest, including
        historical Options Premiums, Volumes, OI and other Historical closing
        data.{' '}
      </div>

      <div style={styles.toolTipWhiteTextMain}>
        <div style={styles.toolTipWhiteText}>
          Tip: Once you access the OI model, get a sense of other big volume
          days in the bar chart. It often starts revealing the beginning a
          story. Click on the Calendar date and pick any one of those important
          dates you find.
        </div>
      </div>
      <div style={styles.textHeading}> IV and Chg </div>
      <div style={styles.NormalText}>
        {' '}
        This is where you will see the Implied Volatility (IV) of the option and
        the 1-day change in the IV.
      </div>

      <div style={styles.toolTipWhiteTextMain}>
        <div style={styles.toolTipWhiteText}>
          Tip: In general, buyers of that option are indicated with a positive
          1-day change. Keep in mind, this is not always the case. Sometimes
          comparing the SPY (S&P500 ETF) IV change over 1-day helps add context.
          If the SPY IV change is negative and a Stock IV is flat, then that
          might also indicate better demand.
        </div>
      </div>
      <div style={styles.textHeading}> Delta </div>
      <div style={styles.NormalText}> ATM = 0.50</div>
      <div style={styles.NormalText}> {secondBoxItm}</div>
      <div style={styles.NormalText}> {secondBoxOTM} </div>
      <div style={styles.toolTipWhiteTextMain}>
        <div style={styles.toolTipWhiteText}>
          Tip: In general, we are looking for buyers of OTM that land within the
          unshaded area on the New Options Chain.
        </div>
      </div>
      <div style={styles.textHeading}> Time </div>
      <div style={styles.NormalText}>
        {' '}
        This is the time that the option trade occurred.
      </div>

      <div style={styles.toolTipWhiteTextMain}>
        <div style={styles.toolTipWhiteText}>
          Tip: This is very useful when confirming spreads. If you sort the
          “Time” column then you will see the options that traded together, i.e.
          at the same time. Once you see the components, then look at the “Side”
          of the trade where it occurred. This helps determine what traded as
          spreads and clarifies what happened i.e. what was bought or sold.
        </div>
      </div>
    </div>
  </div>
);

export const HomePageTable1 = (
  <div style={{ margin: '5%' }}>
    <div>
      <div style={styles.headingText}> Top Options Trades </div>
      <div style={{ ...styles.NormalText, marginLeft: '0px' }}>
        This will likely become your go-to place to quickly find options trading
        ideas. I’ve made it simple by aggregating the top individual options
        trades in the market happening today. You can also go back historically
        to get data by using the calendar.
      </div>
      <div style={styles.imageDiv}>
        <div style={{ width: isMobile ? '300px' : '500px' }}>
          <iframe
            width="200"
            height={videoHeight}
            src="https://player.vimeo.com/video/709676798?h=f7db501b4c&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            title="Home - Top Options Trade"
            style={{ width: isMobile ? '300px' : '500px', maxWidth: '500px' }}
          />
        </div>
      </div>

      {/* <img src={ComingSoon} width={widthofImage}></img> */}
    </div>
    <div style={isMobile ? styles.scrollAbleDivMobile : styles.scrollAbleDiv}>
      <div style={styles.textHeading}>Size</div>
      <div style={styles.NormalText}>
        Size is the number of contracts on a particular trade with details shown
        to the right. Size is not the total volume for the ticker or for that
        strike. Sometimes you can see multiple trades in the same option because
        they traded at different times. For example, 10,000 options trade now
        and 5 minutes later. You will see two separate trades with separate
        times.
      </div>
      <div style={styles.NormalText}>
        You can click any cell to get a detailed look (i.e. volume, Implied
        Volatility and Stock Price by time during the day) at the volume for
        that specific option.
      </div>

      <div style={styles.toolTipWhiteTextMain}>
        {' '}
        <div style={styles.toolTipWhiteText}>
          Tip: The data set is very helpful in finding details on “spreads” and
          helping us determine the direction of those spreads. Use with columns
          “Side,” “Condition,” and “Time”
        </div>
      </div>
      <div style={styles.textHeading}>Ticker</div>
      <div style={styles.NormalText}>
        Click any Stock ticker to be sent to that Stock’s home page where you
        could investigate all the options volume for that stock.{' '}
      </div>
      <div style={styles.textHeading}>Expiry </div>
      <div style={styles.NormalText}>
        Click any cell to access the New Options Chain for a broader look at
        current markets across all expirations and the Risk Reward Stock Price.{' '}
      </div>
      <div style={styles.textHeading}>Side</div>
      <div style={styles.NormalText}>
        This gives you the side of the market that the option traded. “BidSide”
        or “BelowBid” indicates a sale, while “AskSide” and “AboveAsk” indicates
        a buyer. “MidMkt” is inconclusive.
      </div>
      <div style={styles.toolTipWhiteTextMain}>
        <div style={styles.toolTipWhiteText}>
          {' '}
          Tip: Sometimes the results come back and it’s easy to decipher what
          happened. But sometimes you can get two options that traded as a
          “Spread” with both on the “AskSide” or show “MidMkt.” This might not
          be conclusive on being a buyer. If there is equal or more OI, you can
          click on the Open Interest cell to determine historical dates where
          that OI traded for further investigation. For example, If they bought
          in the past, then today’s flow might be a sale.{' '}
        </div>
      </div>
      <div style={styles.textHeading}>Stock & Chg</div>
      <div style={styles.NormalText}>
        This gives you the Stock Price and the change on the day at the time
        this option traded.
      </div>
      <div style={styles.toolTipWhiteTextMain}>
        <div style={styles.toolTipWhiteText}>
          Tip: You will need to click on the Ticker to go to the home page but
          consider what has happened to the stock after these options traded.
          This gives you another clue to whether the option was a bought or a
          sold. In general, Call buying creates buying pressure on the stock.
          Put buying places selling pressure on the stock.{' '}
        </div>
      </div>
      <div style={styles.textHeading}>Condition </div>
      <div style={styles.NormalText}>
        {' '}
        This will give you more information on the type of trade that happened:{' '}
      </div>
      <div style={styles.NormalText}>
        {' '}
        SWEEP – Sweep trade done, which means the trade was done across
        several/all markets at one time.{' '}
      </div>
      <div style={styles.NormalText}>
        {' '}
        SPRD/FLR – This is a Spread trade, where the market makers took the
        other side of the trade.{' '}
      </div>
      <div style={styles.NormalText}>
        {' '}
        SPRD/CROSS - This is a Spread trade, where the Broker (i.e. Goldman
        Sachs) took the other side of the trade.{' '}
      </div>
      <div style={styles.NormalText}> AUCT </div>
      <div style={styles.toolTipWhiteTextMain}>
        <div style={styles.toolTipWhiteText}>
          {' '}
          Tip: Just because the “Condition” does not say “SPRD” (Spread), it can
          still be part of a spread. Sometimes the trade tickets don’t get
          processed correctly.{' '}
        </div>
      </div>
      <div style={styles.textHeading}> Volume </div>
      <div style={styles.NormalText}>
        {' '}
        This is the total Volume for that Options Strike. It will always be
        greater or equal to the Size column.{' '}
      </div>
      <div style={styles.toolTipWhiteTextMain}>
        <div style={styles.toolTipWhiteText}>
          {' '}
          Tip: Just because the Size of the trade is dwarfed by the Volume, it
          does not mean that it was not a Top 1% player. Sometimes they buy in
          pieces during the day that add up to most of the volume. Click on the
          “Size” cell to access the details of the trade and get a feel for how
          the volume accumulated during the day.
        </div>
      </div>
      <div style={styles.textHeading}> OI </div>
      <div style={styles.NormalText}>
        {' '}
        Click any cell to access more details about the Open Interest, including
        historical Options Premiums, Volumes, OI and other Historical closing
        data.{' '}
      </div>

      <div style={styles.toolTipWhiteTextMain}>
        <div style={styles.toolTipWhiteText}>
          Tip: Once you access the OI model, get a sense of other big volume
          days in the bar chart. It often starts revealing the beginning a
          story. Click on the Calendar date and pick any one of those important
          dates you find.
        </div>
      </div>
      <div style={styles.textHeading}> IV and Chg </div>
      <div style={styles.NormalText}>
        {' '}
        This is where you will see the Implied Volatility (IV) of the option and
        the 1-day change in the IV.
      </div>

      <div style={styles.toolTipWhiteTextMain}>
        <div style={styles.toolTipWhiteText}>
          Tip: In general, buyers of that option are indicated with a positive
          1-day change. Keep in mind, this is not always the case. Sometimes
          comparing the SPY (S&P500 ETF) IV change over 1-day helps add context.
          If the SPY IV change is negative and a Stock IV is flat, then that
          might also indicate better demand.
        </div>
      </div>
      <div style={styles.textHeading}> Delta </div>
      <div style={styles.NormalText}> ATM = 0.50</div>
      <div style={styles.NormalText}> {secondBoxItm}</div>
      <div style={styles.NormalText}> {secondBoxOTM} </div>
      <div style={styles.toolTipWhiteTextMain}>
        <div style={styles.toolTipWhiteText}>
          Tip: In general, we are looking for buyers of OTM that land within the
          unshaded area on the New Options Chain.
        </div>
      </div>
      <div style={styles.textHeading}> Time </div>
      <div style={styles.NormalText}>
        {' '}
        This is the time that the option trade occurred.
      </div>

      <div style={styles.toolTipWhiteTextMain}>
        <div style={styles.toolTipWhiteText}>
          Tip: This is very useful when confirming spreads. If you sort the
          “Time” column then you will see the options that traded together, i.e.
          at the same time. Once you see the components, then look at the “Side”
          of the trade where it occurred. This helps determine what traded as
          spreads and clarifies what happened i.e. what was bought or sold.
        </div>
      </div>
    </div>
  </div>
);

export const HomePageTable2 = (
  <div style={{ margin: '5%' }}>
    <div>
      <div style={styles.headingText}> Top Open Interest Trades </div>
      <div style={{ ...styles.NormalText, marginLeft: '0px' }}>
        This data box highlights the largest one-day changes in Open Interest on
        a strike basis. You can also change the calendar date to get historical
        data.
      </div>
      <div style={styles.imageDiv}>
        <div style={{ width: isMobile ? '300px' : '500px' }}>
          <iframe
            width="200"
            height={videoHeight}
            src="https://player.vimeo.com/video/709676831?h=c0f02e0e0a&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            title="Home - Top Options Trade"
            style={{
              width: isMobile ? '300px' : '500px',
              maxWidth: '500px',
            }}
          ></iframe>
        </div>

        {/* <img src={ComingSoon} width={widthofImage}></img> */}
      </div>
    </div>
    <div style={isMobile ? styles.scrollAbleDivMobile : styles.scrollAbleDiv}>
      <div style={styles.textHeading}>OI & Chg</div>
      <div style={styles.NormalText}>
        This gives you the Open Interest and the one-day change in Open Interest
        for a specific option. It’s important because it can give you some
        indication of what you may have missed the previous day. Click any{' '}
      </div>
      <div style={styles.textHeading}>Volume</div>
      <div style={styles.NormalText}>
        Click any cell to get a detailed look (i.e. volume, Implied Volatility
        and Stock Price by time during the day) at the volume for that specific
        option.{' '}
      </div>
      <div style={styles.toolTipWhiteTextMain}>
        {' '}
        <div style={styles.toolTipWhiteText}>
          Tip: Use this data set to give you a general sense of what is going on
          in the name. Usually, the top few rows tell most of the “story” of
          where the action is.
        </div>
      </div>

      <div style={styles.textHeading}>Ticker </div>
      <div style={styles.NormalText}>
        Click any Stock ticker to be sent to that Stock’s home page where you
        could investigate all the options volume for that stock.{' '}
      </div>
      <div style={styles.textHeading}>Expiry</div>
      <div style={styles.NormalText}>
        Click any cell to access the New Options Chain for a broader look at
        current markets across all expirations and the Risk Reward Stock Price.{' '}
      </div>
      <div style={styles.textHeading}>Bid%, Mid%, Ask%</div>
      <div style={styles.NormalText}>
        Today’s volume is divided into 3 percentage buckets determined by where
        the premium traded relative to the market at the time of the trade. This
        is not precise but the machine’s best guess using proprietary proximity
        analysis, meaning it doesn’t have to trade on the bid to fall in the
        bid% bucket. Volume that is “close to the bid” could be thrown into the
        Bid% bucket.{' '}
      </div>
      <div style={styles.toolTipWhiteTextMain}>
        {' '}
        <div style={styles.toolTipWhiteText}>
          Tip: Our main goal is to look for buyers. A good sign is seeing a
          higher % on the Ask. That does not make it definitive as discussed in
          3 Steps to Profit. But it’s a good start.
        </div>
      </div>
      <div style={styles.textHeading}>IV & Chg</div>
      <div style={styles.NormalText}>
        {' '}
        This is where you will see today’s Implied Volatility (IV) of the option
        and the 1-day change in the IV.
      </div>
      <div style={styles.toolTipWhiteTextMain}>
        {' '}
        <div style={styles.toolTipWhiteText}>
          Tip: In general, buyers of that option are indicated with a positive
          1-day change. Keep in mind, this is not always the case. Sometimes
          comparing the SPY (S&P500 ETF) IV change over 1-day helps add context.
          If the SPY IV change is negative and a Stock IV is flat, then that
          might also indicate better demand.
        </div>
      </div>
    </div>
  </div>
);

export const WatchListAdd = (
  <div style={{ margin: '5%' }}>
    <div>
      <div style={styles.headingText}> Stock Watchlist </div>
      <div style={styles.imageDiv}>
        <div style={{ width: isMobile ? '300px' : '500px' }}>
          <iframe
            width="200"
            height={videoHeight}
            src="https://player.vimeo.com/video/723837498?h=f543add098&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            title="Home - Top Options Trade"
            style={{
              width: isMobile ? '300px' : '500px',
              maxWidth: '500px',
            }}
          ></iframe>
        </div>

        {/* <img src={ComingSoon} width={widthofImage}></img> */}
      </div>
    </div>
    <div style={isMobile ? styles.scrollAbleDivMobile : styles.scrollAbleDiv}>
      <div style={styles.textHeading}>To Add a Stock to your Watchlist</div>
      <div style={styles.NormalText}>
        1. Enter Ticker. Do NOT include spaces
      </div>
      <div style={styles.NormalText}>
        2. Click the GO button to add the stock{' '}
      </div>
      <div style={styles.textHeading}>
        {' '}
        To Delete a Stock From your Watchlist{' '}
      </div>
      <div style={styles.NormalText}>1. Find the Ticker on your Watchlist </div>
      <div style={styles.NormalText}>2. Check the Box</div>
      <div style={styles.NormalText}>
        3. Click the Garbage Can Icon to Delete{' '}
      </div>
      <div style={styles.textHeading}>Where to Use Your Watchlist</div>
      <div style={styles.NormalText}> 1. Click the Home Page</div>
      <div style={styles.NormalText}>
        {' '}
        2. In the "Group" dropdown, select "My Watchlist"{' '}
      </div>
    </div>
  </div>
);

export const HomePageTable3 = (
  <div style={{ margin: '5%' }}>
    <div>
      <div style={styles.headingText}> Options Summary By Sectors </div>
      <div style={{ ...styles.NormalText, marginLeft: '0px' }}>
        Here you’ll find a summary page of the options market divided by
        sectors.
      </div>
      <div style={styles.imageDiv}>
        <div style={{ width: isMobile ? '300px' : '500px' }}>
          <iframe
            width="200"
            height={videoHeight}
            src="https://player.vimeo.com/video/709676856?h=f543add098&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            title="Home - Top Options Trade"
            style={{
              width: isMobile ? '300px' : '500px',
              maxWidth: '500px',
            }}
          ></iframe>
        </div>

        {/* <img src={ComingSoon} width={widthofImage}></img> */}
      </div>
    </div>
    <div style={isMobile ? styles.scrollAbleDivMobile : styles.scrollAbleDiv}>
      <div style={styles.textHeading}>Description</div>
      <div style={styles.NormalText}>
        Click on any cell to change the “Group” filter at the top of the page.
      </div>
      <div style={styles.textHeading}>Calls</div>
      <div style={styles.NormalText}>
        Today’s aggregate number of Calls that traded in the sector.{' '}
      </div>
      <div style={styles.textHeading}>Puts </div>
      <div style={styles.NormalText}>
        Today’s aggregate number of Puts that traded in the sector.{' '}
      </div>
      <div style={styles.textHeading}>Total</div>
      <div style={styles.NormalText}>
        Today’s Total volume of options that traded in the sector. It is the sum
        of Calls and Puts.
      </div>
      <div style={styles.textHeading}>%Adv</div>
      <div style={styles.NormalText}>
        This is the % of the Average Daily Volume that compares today’s volume
        versus the 30-day average volume.{' '}
      </div>
      <div style={styles.textHeading}>Tw%Adv </div>
      <div style={styles.NormalText}>
        {' '}
        This is the “Time-Weighted Average Daily Volume.” At the end of the day,
        this will match the %Adv. I think it is a better metric because it
        compares the volume according to time in order to compare apples vs
        apples. For example, if it is 11am, then the machine is comparing
        today’s volume at 11am vs the 30-day average volume… at 11am.
      </div>

      <div style={styles.textHeading}> Call% & Put% </div>
      <div style={styles.NormalText}>
        {' '}
        This is the Call and Put Volume as a % of Total Volume.{' '}
      </div>
      <div style={styles.textHeading}> Bear% & Bull% </div>
      <div style={styles.NormalText}>
        {' '}
        The machine aggregates all trades that it can decipher to be
        directionally positive or directionally negative. In general, mid-market
        trades are not conclusive. Directionally positive trades are Buy Calls
        or Sell Puts. Directionally negative trades are Buy Puts or Sell Calls{' '}
      </div>

      <div style={styles.textHeading}> ETF & Chg% </div>
      <div style={styles.NormalText}>
        {' '}
        This highlights an ETF and its daily price change as a benchmark
        relative to the given sectors.
      </div>
    </div>
  </div>
);

export const WatchListTable = (
  <div style={{ margin: '5%' }}>
    <div>
      <div style={styles.headingText}> Options Watchlist </div>
      <div style={styles.imageDiv}>
        <div style={{ width: isMobile ? '300px' : '500px' }}>
          <iframe
            width="200"
            height={videoHeight}
            src="https://player.vimeo.com/video/723837553?h=f543add098&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            title="Home - Top Options Trade"
            style={{
              width: isMobile ? '300px' : '500px',
              maxWidth: '500px',
            }}
          ></iframe>
        </div>

        {/* <img src={ComingSoon} width={widthofImage}></img> */}
      </div>
    </div>
    <div style={isMobile ? styles.scrollAbleDivMobile : styles.scrollAbleDiv}>
      <div style={styles.textHeading}>To Add an Option to the Watchlist</div>
      <div style={styles.NormalText}>
        1. Go to the New Options Chain (or “Chain” on Mobile)
      </div>
      <div style={styles.NormalText}>2. Enter a stock symbol & press “GO”</div>
      <div style={styles.NormalText}> 3. Click on an Expiration </div>
      <div style={styles.NormalText}>
        4. Above the Options Chain, click on the Glasses icon (click box on
        Mobile){' '}
      </div>
      <div style={styles.NormalText}>
        5. Select the Option(s) you wish to save.
      </div>
      <div style={styles.NormalText}>6. Click on the Glasses Icon again. </div>
      <div style={styles.textHeading}>
        7. Confirm the Option(s) by pressing “GO”
      </div>
      <div style={styles.NormalText}>
        To Delete an Option from your Watchlist
      </div>

      <div style={styles.NormalText}> 1. Click on the Glasses icon.</div>
      <div style={styles.NormalText}>
        {' '}
        2. Select the Option(s) you wish to delete.{' '}
      </div>
      <div style={styles.NormalText}> 3. Click on the Glasses icon again. </div>
      <div style={styles.NormalText}>
        {' '}
        4. Confirm the Option(s) to be deleted{' '}
      </div>
      <div style={styles.textHeading}>Clickable Cells</div>
      <div style={styles.NormalText}>
        {' '}
        “Options” Column – Get historical data on the Options Premium{' '}
      </div>
      <div style={styles.NormalText}>
        {' '}
        “RR$” Column – See a graph of the RR$ over time.{' '}
      </div>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/Pages/Stock/constants.js